export default __webpack_public_path__ + "static/media/icon-upload.1ab310ee.svg";